<div class='width-1100'>

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>star</mat-icon>
        <div>{{uid}}</div>
      </div>

      <a mat-button (click)="openDialog(null)" style='width:60px;'>
        <mat-icon color='primary'>add_circle_outline</mat-icon>
      </a>

    </mat-toolbar>
  </mat-card>

  <!--
  <mat-card style="display: flex; flex-direction: coluumn; justify-content: flex-end;">
    <button mat-raised-button (click)='gotoPublish()' style="color: green;">
      Publicar
    </button>
    <button mat-raised-button (click)='gotoSchedule()'  style="color: green; margin-left: 20px;">
      Visualizar
    </button>
  </mat-card>
  -->

  <mat-card id='table-body'>

    <!-- TABLE -->
    <mat-table [dataSource]="_eventService.eventDataSource">

      <!-- Icon Column -->
      <ng-container matColumnDef="icon" class='mural-name'>
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-icon style='font-size:1.2em; margin-top:10px;'>star</mat-icon>
        </mat-cell>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
      </ng-container>

      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef> Data </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.startDay | date: 'dd/MM/yyyy' }} </mat-cell>
      </ng-container>

      <!-- preview Column -->
      <ng-container matColumnDef="preview">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='preview(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-close'>
              menu
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- edit Column -->
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='openDialog(element)' style='background-color: whitesmoke;'>
            <mat-icon class="icon-info">
              info_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- delete Column -->
      <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef>
          <a *ngIf="selectedContext" mat-button (click)="openDialog(null)" style='width:60px;'>
            <mat-icon color='primary'>add_circle_outline</mat-icon>
          </a>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='delete(element)' style='background-color: whitesmoke;'>
            <mat-icon class="icon-delete">delete_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>


      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <!-- END TABLE -->

  </mat-card>

<mat-paginator [pageSizeOptions]="[9, 13, 26, 50]"></mat-paginator>


</div>